var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLoveGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 31 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0941 0.799805C25.6832 0.79988 29.3998 4.53144 29.3998 9.13672C29.3998 10.826 29.1286 12.3899 28.6595 13.8398L28.6605 13.8408C27.5366 17.393 25.2526 20.205 22.8588 22.2598C20.4686 24.3114 17.923 25.648 16.1947 26.2354L16.1937 26.2344C15.854 26.3525 15.4578 26.3994 15.1 26.3994C14.7419 26.3994 14.3452 26.3528 14.0052 26.2344V26.2354C12.277 25.648 9.73136 24.3114 7.34119 22.2598C4.9473 20.205 2.66333 17.393 1.53943 13.8408L1.54041 13.8398C1.07135 12.3899 0.800174 10.826 0.800171 9.13672C0.800171 4.53144 4.51678 0.799881 9.10583 0.799805C11.4573 0.799805 13.5916 1.79225 15.1 3.37207C16.6083 1.79225 18.7426 0.799805 21.0941 0.799805Z",
    stroke: "#5D5D5D",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoveGrey);
export default __webpack_public_path__ + "static/media/Icon-love-grey.1f82b5c294e97910d626deb8429a10e7.svg";
export { ForwardRef as ReactComponent };